export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YNpoilQs6yLUrwB0lw.64bbc644.woff2";